import React from 'react';
import { Label, TextField, Text, Stack, Icon, DefaultButton, DetailsList, DetailsListLayoutMode, SelectionMode, IconButton } from '@fluentui/react';
import SingleFileDropzone from '../../Common/FileDropzone/SingleFileDropzone';
import { checkMaxSize } from '../WizardRegistroEntrenador';
import CustomInputIfc from '../../../lib/FormValidator/Form/CustomInputIfc';
import InputField from '../../../lib/FormValidator/Form/InputField';
import MessageCourier from '../../../lib/MessageCourier';
import SystemClient from '../../../system/SystemClient';
import {RegistroEntrenadorTitulo} from '../../../system/RegistroEntrenadorTitulo/RegistroEntrenadorTitulo';
import RegistroEntrenadorForm from '../../RegistroEntrenador/RegistroEntrenadorForm';
import RegistroEntrenadorTituloForm from '../../RegistroEntrenadorTitulo/RegistroEntrenadorTituloForm';
import ToggleInput from '../../../lib/FormValidator/Form/ToggleInput';
import { useCustomInput } from '../../../common/custom-hooks/useCustomInput';
import useForceUpdate from '../../../common/custom-hooks/useForceUpdate';
import GridListIconFormat from '../../Common/GridListIconFormat';
import { formatFileSize, obtenerExtension } from '../WizardRegistroEntrenador';
import { getPropsWithDefaults } from 'office-ui-fabric-react';

interface IOtrosTitulos {
  form: RegistroEntrenadorForm;
  onBlurCustomInput: (customInput: CustomInputIfc) => void;
  system: SystemClient;
  courier: MessageCourier;
  onNextEnable: (valid: boolean) => void;
}

export const OtrosTitulos = ({ form, onBlurCustomInput, system, courier, onNextEnable }: IOtrosTitulos) => {

  const [showAddAnother, setShowAddAnother] = React.useState(false);

  const [tituloForm, setTituloForm] = React.useState<RegistroEntrenadorTituloForm>(
    RegistroEntrenadorTituloForm.initialize()
  );

  const forceUpdate = useForceUpdate();
  const [formIsValid, setFormIsValid] = React.useState(false);

  const titulosList = useCustomInput(() => form.getTituloEntrenadorListInput(), [form]);
  const tituloInput = useCustomInput(() => tituloForm.getTituloInput(), [tituloForm]);
  const otorgadoPorInput = useCustomInput(() => tituloForm.getOtorgadoPorInput(), [tituloForm]);
  const docenteInput = useCustomInput(() => tituloForm.getDocenteInput(), [tituloForm]);
  const añoEgresoInput = useCustomInput(() => tituloForm.getAnioEgresoInput(), [tituloForm]);
  const tituloImagenInput = useCustomInput(() => tituloForm.getImagenTituloInput(), [tituloForm]);
  

  React.useEffect(() => {
    
    if (titulosList.getValue().filter((titulo: any) => titulo.anioEgreso == null).length > 0) {
      setShowAddAnother(true);
      onNextEnable(true);
    }
  }, [])

  const onDropTitulo = (file: File) => {
    tituloImagenInput.setValue(file)
  }

  const addTitulo = () => {
    const titulos = [...titulosList.getValue()];
    titulos.push(tituloForm.toRegistroEntrenadorTitulo());
    titulosList.setValue(titulos);
    setTituloForm(RegistroEntrenadorTituloForm.initialize());
    onBlurCustomInput(titulosList);
    setShowAddAnother(true);
    onNextEnable(true);
  }

  const showAddAnotherFn = (value: boolean) => {
    setShowAddAnother(value);
    onNextEnable(value);
  }

  const onBlurTitulos = (customInput: CustomInputIfc) => {
    if (tituloForm) {
      const isValid = tituloForm.getIdInput().getValue()
        ? !tituloForm.hasErrors()
        : tituloForm?.isValid();
      setFormIsValid(isValid);
      forceUpdate();
      return isValid;
    }
    return false;
  };

  React.useEffect(() => {
    console.log(titulosList.getValue());
  }, [titulosList]);

  const onRenderIndexColumn = (item?: any, index?: number, column?: any) => {
    return <span>{index !== undefined ? index + 1 : ''}.</span>;
  };

  const columns = [
    {
      key: 'index',
      name: '',
      fieldName: 'index',
      minWidth: 3,
      maxWidth: 3,
      onRender: onRenderIndexColumn,
    },
    {
      key: 'titulo',
      name: 'Titulo',
      fieldName: 'titulo',
      minWidth: 50,
      maxWidth: 73,
      isMultiline: true,
    },
    {
      key: 'otorgadoPor',
      name: 'Otorgado por',
      fieldName: 'otorgadoPor',
      minWidth: 50,
      maxWidth: 88,
      isMultiline: true,
    },
    {
      key: 'docente',
      name: 'Docente',
      fieldName: 'docente',
      minWidth: 50,
      maxWidth: 55,
      isMultiline: true,
      onRender: (item: any) => {
        return <GridListIconFormat formField={item.docente} width={50} />;
      },
    },
    {
      key: 'delete',
      name: '',
      fieldName: 'delete',
      minWidth: 10,
      maxWidth: 10,
      onRender: (item: RegistroEntrenadorTitulo) => (
        <Icon iconName="Trash" onClick={() => handleDelete(item)} styles={iconStyles}/>
      ),
    },
  ];

  const iconStyles = {
    root: {
      cursor: 'pointer',
      fontSize: '20px',
    },
  };

  const handleDelete = (tituloToDelete: RegistroEntrenadorTitulo) => {
    titulosList.setValue(
      titulosList.getValue().filter((titulo: RegistroEntrenadorTitulo) => titulo !== tituloToDelete)
    );
    onBlurCustomInput(titulosList);
  };

  const disableAdd = () => {
    const ret = !tituloForm.getTituloInput().getValue() || !tituloForm.getOtorgadoPorInput().getValue();
    onNextEnable(ret);
    return ret;
  }

  const disableCancel = () => {
    const ret = !tituloForm.getTituloInput().getValue() && !tituloForm.getOtorgadoPorInput().getValue();
    onNextEnable(ret);
    return ret;
  }

  const cancelAdd = () => {
      setTituloForm(RegistroEntrenadorTituloForm.initialize());
  }

  return (
    <div>
      <div className="ms-Grid" dir="ltr">
        {docenteInput.getValue() && (
          <Text
            className="mb-1"
            variant="small"
            styles={{ root: { textAlign: 'center', color: '#666', display: 'block' } }}
          >
            (En caso de títulos intermedios u obtenidos a lo largo de una misma carrera, en orden
            necesariamente sucesivo, se valorará solamente el obtenido en último término).
          </Text>
        )}

        {showAddAnother ? (
          <div className="ms-Grid-row mt-2">
            <div className="ms-Grid-col ms-sm12 form-item">
              <DefaultButton
                onClick={() => showAddAnotherFn(false)}
                text="Agregar otro"
                styles={{ root: { width: '100%' } }}
                primary
              />
            </div>
          </div>
        ) : (
          <>
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm12 form-item">
                <InputField input={tituloInput} label={'Titulo'} onBlur={onBlurTitulos} />
              </div>
            </div>

            <div className="ms-Grid-row mt-2">
              <div className="ms-Grid-col ms-sm12 form-item">
                <InputField input={otorgadoPorInput} label={'Otorgado por'} onBlur={onBlurTitulos} />
              </div>
            </div>

            <div className="ms-Grid-row mt-2">
              <div className="ms-Grid-col ms-sm6 form-item" style={{ display: 'flex', flexDirection: 'row' }}>
                <Label className="mr-2" style={{ padding: 0 }}>
                  Docente
                </Label>
                <ToggleInput input={docenteInput} offText={'No'} onText={'Sí'} onBlur={onBlurTitulos} />
              </div>
            </div>

            <div className="ms-Grid-row mt-2">
              <Stack horizontalAlign="center" className="text-center mt-1">
                {' '}
                <SingleFileDropzone
                  label="Título"
                  icon="Camera"
                  onDrop={(file) => onDropTitulo(file)}
                ></SingleFileDropzone>
              </Stack>{' '}
              <div className="text-center">
                <Text variant="xSmall" className="" title="Formatos admitidos">
                  (JPG, JPEG, GIF, PNG, PDF)
                </Text>
              </div>
              {tituloForm.getImagenTituloInput().getValue() && (
                <div className="mt-2 text-center">
                  <Text block variant="medium" className="">
                    <Icon iconName="SkypeCircleCheck" style={{ color: '#107C10', marginRight: 10 }}></Icon>
                    Archivo {obtenerExtension(tituloForm.getImagenTituloInput().getValue().name)} cargado -{' '}
                    {formatFileSize(tituloForm.getImagenTituloInput().getValue().size)}
                  </Text>
                  {!checkMaxSize(tituloForm.getImagenTituloInput().getValue().size) && (
                    <Text block variant="medium" className="error-color">
                      El tamaño de la foto es demasiado grande, el maximo es de 20MB
                    </Text>
                  )}
                </div>
              )}
            </div>

            <div className="ms-Grid-row mt-2">
              <div className="ms-Grid-col ms-sm12 form-item">
                <DefaultButton
                  disabled={disableAdd()}
                  onClick={addTitulo}
                  text="Agregar"
                  styles={{ root: { width: '100%' } }}
                  primary
                />
                <DefaultButton 
                disabled={disableCancel()} 
                onClick={cancelAdd} 
                text="Cancelar"
                styles={{ root: { width: '100%', marginTop: 8} }} />
              </div>
            </div>
          </>
        )}

        {/* {titulosList.getValue().map((titulo: RegistroEntrenadorTitulo, index: number) => ( */}
        <div className="ms-Grid-row mt-2">
          <div className="ms-Grid-col ms-sm12 form-item">
            <DetailsList
              items={titulosList
                .getValue()
                .filter((titulo: RegistroEntrenadorTitulo) => titulo.getAnioEgreso() === null)}
              columns={columns}
              layoutMode={DetailsListLayoutMode.fixedColumns}
              selectionMode={SelectionMode.none}
            />
          </div>
        </div>
        {/* ))} */}
      </div>
    </div>
  );
};
